import FormLabel from '@mui/material/FormLabel';

export { FormLabel };
